import 'reset-css';
import './App.css';

import React, { useEffect } from 'react';
import Welcome from "./Welcome";
import Manage from "./Manage";
import Assess from "./Assess";
import Report from "./Report";
import Links from "./Links";
import About from "./About";
import Language from "../modules/Language";
import English from "../localization/English";
import French from "../localization/FrenchFromAPI";
import { connect } from "react-redux";
import Actions from "../modules/actions";
import headerImg from "../images/Birdsafe_App_Logo_4.png";
import footerImg from "../images/BirdSafeFacebook.jpg";

import {Typography} from "@material-ui/core";

const centerImage = {
  maxWidth: "100%",
  maxHeight: "100%",
  marginLeft: "auto",
  marginRight: "auto",
  display: "block",
  marginBottom: "10px",
}

const mapStateToProps = (state, ownProps) => {
  return ({
    lang: Language.isEnglish(state.lang) ? English : French,
  });
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  expandSection: section => dispatch(Actions.expandSection(section)),
  collapseSection: section => dispatch(Actions.collapseSection(section)),
});

const App = props => {
  useEffect(() => {
    props.expandSection("Welcome");
    props.collapseSection("Manage");
    props.collapseSection("Assess");
    props.collapseSection("Report");
    props.collapseSection("Links");
    props.collapseSection("About");
  }, []);

  const Lang = props.lang;
  return (
    <div className="App" style={{
      textAlign: "center",
      fontFamily: "Arial",
    }}>
      <img src={headerImg} style={centerImage} alt="Birdsafe Header Logo"></img>
      
      <Welcome lang={Lang}></Welcome>

      <Manage lang={Lang}></Manage>

      <Assess lang={Lang}></Assess>
      
      <Report lang={Lang}></Report>
      
      <Links lang={Lang}></Links>
      
      <About lang={Lang}></About>

      <img src={footerImg} style={centerImage} alt="Birdsafe Footer Logo"></img>

      <div style={{
        display: "flex",
        flexDirection: "column",
      }}>
        
      <Typography>{Lang.copyright}</Typography>
      <Typography>{Lang.developers}</Typography>
        
      </div>
    </div>
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App);



// WEBPACK FOOTER //
// ./src/pages/App.js